import { Box, styled, StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledRoot = styled(Box)``;
export const StyledShowcaseContainer = styled(Box)``;
export const StyledFeaturedContainer = styled(Box)``;

const rootStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignSelf: 'center',
  alignItems: 'center',
};

const showcaseContainerStyles: StyleSystemProps = {
  width: '100%',
  marginTop: 7,
  marginBottom: 7,
};

const featuredContainerStyles: StyleSystemProps = {
  width: '100%',
  margin: pxToRem(98),
  marginY: 6,
};

export const styles = {
  root: rootStyles,
  showcaseContainer: showcaseContainerStyles,
  featuredContainer: featuredContainerStyles,
};
